import { render, staticRenderFns } from "./Gold.vue?vue&type=template&id=6ca7c759"
import script from "./Gold.vue?vue&type=script&lang=js"
export * from "./Gold.vue?vue&type=script&lang=js"
import style0 from "./Gold.vue?vue&type=style&index=0&id=6ca7c759&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports